import type { BatchJobAcceptedResponse, BatchJobStatusResponse, BatchAdminAccessResponse, BatchJobSummaryResponse } from '../shared/types';
import { authenticatedFetch } from '../shared/authenticatedFetch';

export async function checkBatchAdminAccess(apiUrl: string): Promise<BatchAdminAccessResponse> {
  const response = await authenticatedFetch(`${apiUrl}/batch-admin/check-access`);
  return response.json();
}

export async function getAreaLevels(apiUrl: string, fiscalYearQuarter: string): Promise<string[]> {
  const response = await authenticatedFetch(
    `${apiUrl}/batch-admin/area-levels?fiscalYearQuarter=${encodeURIComponent(fiscalYearQuarter)}`
  );
  return response.json();
}

export async function triggerBatchDatabricks(
  apiUrl: string,
  fiscalYearQuarter: string,
  areaLevel1?: string
): Promise<BatchJobAcceptedResponse> {
  let url = `${apiUrl}/assessments/batch-databricks?fiscalYearQuarter=${encodeURIComponent(fiscalYearQuarter)}`;
  if (areaLevel1) {
    url += `&areaLevel1=${encodeURIComponent(areaLevel1)}`;
  }
  const response = await authenticatedFetch(url, { method: 'POST' });
  return response.json();
}

export async function getBatchJobStatus(apiUrl: string, jobId: string): Promise<BatchJobStatusResponse> {
  const response = await authenticatedFetch(`${apiUrl}/assessments/batch/${jobId}`);
  return response.json();
}

export async function getFailedBatchJobs(apiUrl: string): Promise<BatchJobSummaryResponse[]> {
  const response = await authenticatedFetch(`${apiUrl}/assessments/batch/failed`);
  return response.json();
}

export async function continueAssessmentJob(apiUrl: string, jobId: string): Promise<BatchJobAcceptedResponse> {
  const response = await authenticatedFetch(`${apiUrl}/assessments/batch/${jobId}/continue`, { method: 'POST' });
  return response.json();
}

export async function continueProjectEvaluationJob(apiUrl: string, jobId: string): Promise<BatchJobAcceptedResponse> {
  const response = await authenticatedFetch(`${apiUrl}/project-evaluations/${jobId}/continue`, { method: 'POST' });
  return response.json();
}

export async function removeBatchJob(apiUrl: string, jobId: string): Promise<void> {
  await authenticatedFetch(`${apiUrl}/assessments/batch/${jobId}/remove`, { method: 'DELETE' });
}

export async function forceFailBatchJob(apiUrl: string, jobId: string): Promise<void> {
  await authenticatedFetch(`${apiUrl}/assessments/batch/${jobId}/force-fail`, { method: 'POST' });
}
